import HTML_PARSER from 'constants/htmlParser';

const PRODUCTS_ALIAS_ATTRIB_NAMES = {
  'data-comparai-id': 'comparaiId',
  'data-position': 'position',
  'data-alias-id': 'aliasId',
  'data-keyword': 'wishlistKeyword',
};

export const doesAnyDomNodeParentContainName = (parent, name = '') => {
  if (parent) {
    if (parent.name === name) {
      return true;
    }

    if (parent?.parent) {
      // eslint-disable-next-line no-unused-vars
      return doesAnyDomNodeParentContainName(parent.parent, name);
    }

    return false;
  }

  return false;
};

export const doesAnyDomNodeParentContainAttribute = ({
  attributeName = 'class',
  attributeValue = '',
  parent,
}) => {
  if (parent) {
    if (parent.attribs[attributeName]?.includes(attributeValue)) {
      return true;
    }

    if (parent?.parent) {
      // eslint-disable-next-line no-unused-vars
      return doesAnyDomNodeParentContainAttribute({
        attributeName,
        attributeValue,
        parent: parent.parent,
      });
    }

    return false;
  }

  return false;
};

const getAttribsFromChildren = (node) => {
  const result = [];

  const getAttribsFromChildrenRecursively = (recursiveNode) => {
    if (!recursiveNode?.attribs && recursiveNode?.data.includes('\n')) {
      getAttribsFromChildrenRecursively(recursiveNode?.next);
      return;
    }

    result.push(recursiveNode?.attribs);

    if (recursiveNode?.children) {
      getAttribsFromChildrenRecursively(recursiveNode?.children[0]);
    }
  };

  getAttribsFromChildrenRecursively(node[0]);

  return result.filter(Boolean);
};

const mountProductAliasObjFromAttribs = (attribs) => {
  const result = {};

  Object.entries(attribs).forEach(([key, value]) => {
    const parsedKey = PRODUCTS_ALIAS_ATTRIB_NAMES[key];

    result[parsedKey] = value;
  });

  return result;
};

export const getProductsAliasFromDomChildren = (children) => {
  const productsAliasAttribs = getAttribsFromChildren(children);

  return productsAliasAttribs.map(mountProductAliasObjFromAttribs);
};

export const hasLineBreakChild = (children) =>
  children?.some(
    ({ name, data }) => name === HTML_PARSER.NAME_BR || isLineBreaker(data)
  );

export const isInlineText = (type) => type === 'text';

export const isLineBreaker = (str) => /^\s{1,}$/.test(str);

export const isYoutubeIframe = (str) => str.includes('www.youtube.com');

export const strip = (str) => str.replace(/(\r\n|\n\r|\n|\r)/gm, '');

export const toChildrenWithoutLineBreaks = (children) =>
  children?.filter(
    (child) =>
      child?.name !== HTML_PARSER.NAME_BR && !isLineBreaker(child?.data)
  ) ?? [];
